import { createNativeStackNavigator } from '@react-navigation/native-stack';

import * as React from 'react';
import { BillPaymentStackRoutes, BillPaymentStackScreenProps } from '../../payment.navigator';
import { OtpConfirmationModal } from './OtpConfirmation.modal.web';
import { OtpConfirmationStackParamList, OtpConfirmationStackRoutes } from './type';

const OtpConfirmStack = createNativeStackNavigator<OtpConfirmationStackParamList>();

export const OtpConfirmationNavigator: React.FC<BillPaymentStackScreenProps<BillPaymentStackRoutes.OtpConfirmation>> = ({ route }) => {
  const { request: data, response, debitAccount, flagUploaded, mode, paymentType, userFee, documentSelected } = route.params || {};
  return (
    <OtpConfirmStack.Navigator
      initialRouteName={OtpConfirmationStackRoutes.OtpConfirmation}
      screenOptions={{
        presentation: 'transparentModal',
        headerShown: false
      }}>
      <OtpConfirmStack.Screen
        name={OtpConfirmationStackRoutes.OtpConfirmation}
        component={OtpConfirmationModal}
        initialParams={{ request: data, response, debitAccount, flagUploaded, mode, paymentType, userFee, documentSelected }}
      />
    </OtpConfirmStack.Navigator>
  );
};
